import { render, staticRenderFns } from "./artMuseum.vue?vue&type=template&id=33c55120&scoped=true&"
import script from "./artMuseum.vue?vue&type=script&lang=js&"
export * from "./artMuseum.vue?vue&type=script&lang=js&"
import style0 from "./artMuseum.vue?vue&type=style&index=0&id=33c55120&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c55120",
  null
  
)

export default component.exports